module.exports = __webpack_public_path__ + "static/media/check.853a0888.svg";